import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
export var PERMISSIONS = [{
  key: 'asset',
  label: 'permission_asset'
}, {
  key: 'playlist',
  label: 'permission_playlist'
}, {
  key: 'nudge',
  label: 'permission_nudge'
}, {
  key: 'user',
  label: 'permission_user'
}, {
  key: 'report',
  label: 'permission_report'
}];
export var EDITABLE_PERMISSION_KEYS = PERMISSIONS.map(function (perm) {
  return perm.key;
});
export var PERMISSION_KEYS = [].concat(_toConsumableArray(EDITABLE_PERMISSION_KEYS), ['settings']);
export var SUPER_USER = 'super';
export var ROLE_OWNER = 'owner';
export var SETTINGS_READ = 'settings_read';
export var SETTINGS_WRITE = 'settings_write';
export var USER_WRITE = 'user_write';
export var USER_READ = 'user_read';
export var REPORT_WRITE = 'report_write';
export var REPORT_READ = 'report_read';
export var NUDGE_WRITE = 'nudge_write';
export var NUDGE_READ = 'nudge_read';
export var PLAYLIST_WRITE = 'playlist_write';
export var PLAYLIST_READ = 'playlist_read';
export var ASSET_WRITE = 'asset_write';
export var ASSET_READ = 'asset_read';
export var lineManagerTeamTypeRoles = ['manager-email', 'manager-employeeid'];